<template>
  <div class="AlarmConfiguration">
    <div class="commonTitle">
      <h4><span>1</span>报警规则</h4>
    </div>
    <div class="commonContentBox configure">
      <div class="offlineAlarmBox">
        <div class="offlineAlarmBox-label">设备离线报警等级</div>
        <div class="offlineAlarmBox-content">
          <el-radio-group v-model="offlineAlarmRadio">
            <el-radio :label="'MINOR'">警告</el-radio>
            <el-radio :label="'MAJOR'">危险</el-radio>
            <el-radio :label="'CRITICAL'">高危</el-radio>
          </el-radio-group>
          <el-button
            style="margin-right: 20px"
            round
            type="primary"
            size="mini"
            @click="offlineAlarmConfirm()"
            >提交</el-button
          >
        </div>
      </div>
      <template v-if="ruleList && ruleList.length">
        <ul v-for="(item, index) in ruleList" :key="index">
          <li style="padding-left: 20px; font-weight: bold">
            <div>{{ item.name }}</div>
            <el-button
              style="margin-right: 20px"
              round
              type="primary"
              size="mini"
              @click="confirm(item)"
              >提交</el-button
            >
          </li>
          <template v-if="item.range">
            <li v-for="(v, i) in item.rules.lower.dValues" :key="i">
              <div style="margin-left: 20px" class="cellBox">
                {{ item.rules.lower.prefix }}
                <el-input-number
                  v-model="v.dValue"
                  controls-position="right"
                  @change="handleChange"
                  size="mini"
                ></el-input-number>
                {{ item.unit }} {{ item.suffix }}
                <span :class="v.key">{{ severityTransform(v.key,v.severity) }}</span>
              </div>
            </li>
            <li v-for="(v, i) in item.rules.upper.dValues" :key="i + v.dValue">
              <div style="margin-left: 20px" class="cellBox">
                {{ item.rules.upper.prefix }}
                <el-input-number
                  v-model="v.dValue"
                  controls-position="right"
                  @change="handleChange"
                  size="mini"
                ></el-input-number>
                {{ item.unit }} {{ item.suffix }}
                <span :class="v.key">{{ severityTransform(v.key,v.severity) }}</span>
              </div>
            </li>
          </template>
          <template v-else>
            <li v-for="(v, i) in item.rules" :key="i">
              <div style="margin-left: 20px" class="cellBox">
                {{ item.prefix }}
                <el-input-number
                  v-if="item.valueType == 'NUMERIC'"
                  v-model="v.value"
                  controls-position="right"
                  @change="handleChange"
                  size="mini"
                ></el-input-number>
                {{ item.unit }} {{ item.suffix }}
                <span :class="v.key">{{ severityTransform(v.key,v.severity) }}</span>
              </div>
            </li>
          </template>
        </ul>
      </template>
      <el-empty v-else description="暂无数据"></el-empty>
    </div>
  </div>
</template>

<script>
import api from "@/api";
export default {
  props: ["activeItem"],
  data() {
    return {
      ruleList: [],
      offlineAlarmRadio: "noLevel",
    };
  },
  methods: {
    async getList() {
      let res = await api.getAlarmConfiguration({
        id: this.activeItem.deviceId
          ? this.activeItem.deviceId
          : this.activeItem.id.id,
      });
      if (res && res.data.code == 200) {
        this.ruleList = res.data.data;
        if (this.ruleList && this.ruleList.length) {
          this.ruleList.map((v) => {
            if (v.rules && v.rules.length) {
              v.rules.map((item) => {
                item.value = item.value ? item.value : undefined;
              });
            }
          });
        }
      }
    },
    handleChange(value) {
      // console.log(value);
    },
    confirm(item) {
      let state = true;
      if (item.range) {
        let lowerState = true,
          upperState = true;
        for (let i = 0; i < item.rules.lower.dValues.length - 1; i++) {
          for (let j = i + 1; j < item.rules.lower.dValues.length; j++) {
            if (
              item.rules.lower.dValues[j].dValue >=
              item.rules.lower.dValues[i].dValue
            ) {
              lowerState = false;
            }
          }
        }
        for (let i = 0; i < item.rules.upper.dValues.length - 1; i++) {
          for (let j = i + 1; j < item.rules.upper.dValues.length; j++) {
            if (
              item.rules.upper.dValues[j].dValue <=
              item.rules.upper.dValues[i].dValue
            ) {
              upperState = false;
            }
          }
        }
        if (lowerState && upperState) {
          state = true;
        } else {
          state = false;
        }
      } else {
        for (let i = 0; i < item.rules.length - 1; i++) {
          for (let j = i + 1; j < item.rules.length; j++) {
            if (item.sort == "asc") {
              //顺序
              if (item.rules[j].value <= item.rules[i].value) {
                state = false;
                break;
              }
            } else {
              if (item.rules[j].value >= item.rules[i].value) {
                state = false;
                break;
              }
            }
          }
        }
      }
      if (state) {
        if (
          item.rules.every((item) => {
            return item.value;
          })
        ) {
          let obj = {};
          for (let key in item.rules) {
            obj[item.rules[key].attribute] = item.rules[key].value;
          }
          return new Promise(async (resolve) => {
            let res = await api.setAlarmConfiguration(
              obj,
              this.activeItem.deviceId
                ? this.activeItem.deviceId
                : this.activeItem.id.id
            );
            if (res && res.status == 200) {
              this.$message.success("提交成功！");
            } else {
              this.$message.error("提交失败!");
            }
            resolve();
          });
        } else {
          this.$message.error("请选择数值");
        }
      } else {
        this.$message.error("报警值设置不符合对应报警等级！请重新填写！");
      }
    },
    async getOfflineAlarm() {
      let res = await api.DMGetAlarmLevel({
        deviceId: this.activeItem.deviceId
          ? this.activeItem.deviceId
          : this.activeItem.id.id,
      });
      if (res && res.data.code == 200) {
        this.offlineAlarmRadio = res.data.data?.alarmLevel;
      }
    },
    async offlineAlarmConfirm() {
      if (["CRITICAL", "MAJOR", "MINOR"].includes(this.offlineAlarmRadio)) {
        let res = await api.DMSetAlarmLevel({
          deviceId: this.activeItem.deviceId
            ? this.activeItem.deviceId
            : this.activeItem.id.id,
          alarmLevel: this.offlineAlarmRadio,
        });
        if (res && res.status == 200) {
          this.$message.success("提交成功！");
        } else {
          this.$message.error("提交失败!");
        }
      } else {
        this.$message.error("请选择设备离线报警等级");
      }
    },
    severityTransform(key,name){
      const map = {
        MINOR:"警告",
        MAJOR:"危险",
        CRITICAL:"高危",
      }
      return map?.[key]||name
    },
  },
  created() {
    this.getList();
    this.getOfflineAlarm();
  },
};
</script>

<style lang="scss" scoped>
.AlarmConfiguration {
  width: 100%;
  height: 100%;
  .configure {
    overflow: auto;
    .offlineAlarmBox {
      @include setFlexBetween;
      height: 60px;
      background-color: #f7f7f7;
      width: 90%;
      margin: 0 auto 10px;
      &-label {
        width: 150px;
        margin-left: 20px;
        font-weight: 700;
      }

      &-content {
        width: calc(100% - 170px);
        @include setFlexBetween;
      }
    }
  }
  ul {
    width: 90%;
    margin: 0 auto 20px;
    .INDETERMINATE {
      color: #499af5;
    }
    .WARNING {
      color: #ffcc00;
    }
    .MINOR {
      color: #ff6600;
    }
    .MAJOR {
      color: #e31313;
    }
    .CRITICAL {
      color: #990000;
    }
    li {
      min-height: 60px;
      @include setFlexBetween;
      .cellBox {
        font-size: 14px;
      }
    }
    li:nth-child(odd) {
      background: #f7f7f7;
    }
    li:nth-child(even) {
      border: 1px solid #f7f7f7;
    }
  }
}
</style>
